::ng-deep .compact-breadcumb-view particle-breadcumb-tab-action{width:100%}::ng-deep particle-participants-entity-manager .pos-relative{height:initial}
/*# sourceMappingURL=participants-entity-manager.component-NUSB3EEE.css.map */
